var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5813 16H.2643V5.3179h3.317V16ZM1.921 3.8607C.8605 3.8607 0 2.9821 0 1.9214S.8605 0 1.921 0s1.921.8607 1.921 1.9214-.8605 1.9393-1.921 1.9393ZM15.9964 16h-3.31v-5.2c0-1.2393-.025-2.8286-1.7246-2.8286-1.7246 0-1.9888 1.3465-1.9888 2.7393V16H5.6595V5.3179h3.1814V6.775h.0464c.4428-.8393 1.5247-1.725 3.1386-1.725C15.3823 5.05 16 7.2607 16 10.1321V16h-.0036Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default ForwardRef;